import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ApiService {
  private headers = new HttpHeaders().set("Content-Type", "application/json").set('observe', 'response');

  constructor(private http: HttpClient) {}
  //get
  doGetObservable(url): Observable<any> {
    return this.http.get(url, { headers: this.headers });
  }

  //get with query params
  doGetObservableForQuery(url, params): Observable<any> {
    return this.http.get(url, { headers: this.headers, params: params });
  }

  doDereferenceGetObservableForQuery(url, params): Observable<any> {
    return this.http.get(url + '?couponName=&emailId=' + params.value.emailId + '&otp=' + params.value.otp + '&phoneNumber=%2B' + params.value.countryCode + params.value.phoneNo    , { observe: 'response', headers: this.headers});
  }

  //Post
  doPostObservable(url, data): Observable<any> {
    return this.http.post(url, JSON.stringify(data), { headers: this.headers });
  }

  //post with query params
  doPostObservableForQuery(url, params): Observable<any> {
    return this.http.post(url, null, { headers: this.headers, params: params });
  }
}
